<template>
  <md-table
    v-model="contacts"
    class="table-striped"
    table-header-color="primary"
  >
    <md-table-row slot="md-table-row" slot-scope="{ item }">
      <md-table-cell md-label="Name">
        {{ item.name }}
      </md-table-cell>
      <md-table-cell md-label="Email">
        {{ item.email }}
      </md-table-cell>
      <md-table-cell md-label="Phone">
        {{ item.phone }}
      </md-table-cell>
      <md-table-cell class="text-right">
        <md-button
          class="md-just-icon md-primary"
          @click="editContact(item.id)"
        >
          <md-icon>create</md-icon> </md-button
        >&nbsp;
        <md-button
          v-if="showDelete"
          class="md-just-icon md-danger"
          @click="deleteContact(item.id)"
        >
          <md-icon>delete</md-icon>
        </md-button>
      </md-table-cell>
    </md-table-row>
    <md-table-empty-state md-label="No Contacts Found"></md-table-empty-state>
  </md-table>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  computed: {
    ...mapGetters({
      contacts: "data-management-client/clientContacts"
    }),
    showDelete() {
      return this.contacts.length > 1;
    }
  },
  methods: {
    deleteContact(id) {
      Swal.fire({
        text: `Are you sure you want to delete this contact?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete them!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("data-management-client/deleteClientContact", id)
            .then(() => {
              this.getClientContactListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    editContact(id) {
      this.$router.push({
        name: "Edit Client Contact",
        params: { clientContactId: id }
      });
    }
  }
};
</script>

<style></style>
